import { find, propEq } from 'ramda';

import { SelectData, SelectOptions } from '#coreComponents/Select/types';
import { QuerySelectOptionsStaticMap } from './types';

interface Option {
  key: string;
  label: string;
}

interface GetQuerySelectStaticOptions {
  map: QuerySelectOptionsStaticMap[];
  variableOptions: Option[];
  selectedKey: string;
}

export function getQuerySelectOptions(
  this: GetQuerySelectStaticOptions,
  prop: string,
) {
  const selectedMap = this.map.find((m) => m.key === this.selectedKey);

  if (selectedMap?.type === 'static') {
    return this.variableOptions.filter((opt) => opt.key === selectedMap[prop]);
  }

  const dynamicVariableOptions = selectedMap?.options?.map((opt) =>
    find(propEq('key', opt))(this.variableOptions),
  ) as SelectOptions[];

  return dynamicVariableOptions || [{ key: 'placeholder', label: '...' }];
}

export function getFilterSelectOptions(
  map: QuerySelectOptionsStaticMap[],
  selectedKey: string,
  filteredOptions: { [index: string]: SelectData },
  selectedFilters: { [key: string]: string[] },
) {
  const selectedMap = map.find((m) => m.key === selectedKey);

  return selectedMap?.filteredOptions?.map((key) => ({
    ...filteredOptions[key],
    meta: {
      ...filteredOptions[key].meta,
      selected: selectedFilters[key],
    },
    key,
  }));
}

export function getDownloadFileName(
  base?: string,
  suffix?: string,
): string | undefined {
  if (!base) {
    return undefined;
  }
  return `${base}${suffix || ''}`;
}
